import SpineWrapper from '@Core/Animation/SpineWrapper';
import { Gamble } from '../Gamble';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';

export class GambleResult {
    static readonly RESULT_SPINE_KEY: string = 'gamble_result';
    static readonly SKIN_NAME: string = 'default';

    public resultSpine: SpineWrapper;

    constructor(gamble: Gamble) {
        this.resultSpine = new SpineWrapper(
            gamble.scene,
            {
                x: gamble.scene.screen.width / 2,
                y: gamble.scene.screen.height / 2
            },
            { dataKey: GambleResult.RESULT_SPINE_KEY, skinName: GambleResult.SKIN_NAME },
            true
        );

        this.resultSpine.spine.zIndex = ELayeringOrder.GAMBLE_RESULT;

        this.resultSpine.spine.visible = false;
    }
}
